<template>
    <list-page>
      <h1 slot="model">{{ banTitle.namez }}</h1>
      <h3 slot="model_y">{{ banTitle.namey }}</h3>
        <template slot="list">
          <list>
            <template slot="listitem">
              <el-skeleton :loading="loadingList">
                <template slot="template">
                  <list-item-gj></list-item-gj>
                  <list-item-gj></list-item-gj>
                </template>
                <template>
                  <router-link :to="'/NewDetail/'+ item.id" target="_blank"
                    v-for="(item,index) in listData" :key="index"
                    v-if="listData.length != 0">
                    <list-item :item="item"></list-item>
                  </router-link>
                  <el-empty v-else description="暂无信息"></el-empty>
                </template>
              </el-skeleton>
            </template>
          </list>
          <page :total="total" :page-size="pageSize" :current-page="currentPage" @pageChange="getData" ></page>
        </template>
    </list-page>
</template>
  
<script>
  import listPage from '@/view/components/listPage.vue'
  import list from '@/view/components/list.vue'
  import listItem from '@/view/components/listItem.vue'
  import listItemGj from '@/view/components/listItemGj.vue'
  import page from '@/view/components/page.vue'

import News from '@/api/api.js'
export default {
  data() {
    return {
      listData: [],
      banTitle: {},
      total: 0,
      pageSize: 2,
      currentPage: 1,
      loadingList: true
    };
  },
  components: {
    listPage,
    list,
    listItem,
    listItemGj,
    page
  },
  created() {
    this.modelChange()
  },
  watch: {
   $route(to,from){
    this.modelChange()
   }
  },
  mounted() {
  },
  methods: {
    async getData(page){
      this.currentPage = page
      // console.log('当前页'+ page)
      this.searchDTO={
        page,   //页数
        limit: this.pageSize,
        classId: this.model  //新闻分类
      };
      let res = await News.getNewList(this.searchDTO);
      // console.log(res)
      // console.log(await News.getNewList(this.searchDTO))
      this.listData = res.data;
      this.loadingList = false
      // console.log(this.listData)
      this.total = res.count
      // console.log('总条数：',this.total,'每页条数：',this.pageSize,'是否隐藏分页',this.total <= this.pageSize)
    },
    modelChange() {
      this.model = this.$route.params.model
      if(this.model==1){
        this.banTitle = {
          namez: '新闻资讯-公司动态',
          namey: 'News & Information'
        }
      }
      if(this.model==2){
        this.banTitle = {
          namez: '新闻资讯-行业新闻',
          namey: 'News & Industry'
        }
      }
      if(this.model==3){
        this.banTitle = {
          namez: '案例展示-典型案例',
          namey: 'Case & Typical'
        }
      }
      if(this.model==4){
        this.banTitle = {
          namez: '案例展示-科技项目',
          namey: 'Case & Probject'
        }
      }
      this.getData()
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/view/webapp/NewPageList.vue